/* eslint-disable linebreak-style */
import './_fitment-table.scss';

const ALLOWED_INDEXES = [0, 1, 2, 3, 4, 5, 6, 13, 14, 16];
const VISIBLE_ROW_COUNT = 4;

function getFitmentData() {
    const dataEl = document.getElementById('fitment-table-data');
    if (!dataEl) return null;
    try {
        return JSON.parse(dataEl.textContent);
    } catch (e) {
        return null;
    }
}

function parseFitmentString(str) {
    if (!str) return [];
    if (typeof str !== 'string') str = String(str);
    return str
        .split(';')
        .map((s) => s.trim())
        .filter(Boolean)
        .map((row) => row.split('|'));
}

function getUrlParams() {
    const params = {};
    const parser = new URLSearchParams(window.location.search);
    for (const param of parser.entries()) {
        params[param[0].toLowerCase()] = param[1];
    }
    return params;
}

function highlightRow(table) {
    const params = getUrlParams();
    if (Object.keys(params).length === 0) return;

    const headerRow = table.getElementsByTagName('tr')[0];
    if (!headerRow) return;
    const headerCells = headerRow.getElementsByTagName('th');
    const paramToColumnIndex = {};

    for (let i = 0; i < headerCells.length; i++) {
        const headerText = headerCells[i].innerText.toLowerCase().replace(/\s+/g, '_');
        paramToColumnIndex[headerText] = i;
    }

    // Only consider params that map to a known column header. Unknown params
    // (e.g. ?variant=, ?utm_source=, ?fbclid=) must not trigger highlighting.
    const recognizedParams = {};
    for (const param in params) {
        const paramKey = param.toLowerCase().replace(/\s+/g, '');
        if (Object.prototype.hasOwnProperty.call(paramToColumnIndex, paramKey)) {
            recognizedParams[paramKey] = params[param];
        }
    }
    if (Object.keys(recognizedParams).length === 0) return;

    const rows = table.getElementsByTagName('tr');

    for (let i = 1; i < rows.length; i++) {
        const cells = rows[i].getElementsByTagName('td');
        let match = true;

        for (const paramKey in recognizedParams) {
            const cellText = cells[paramToColumnIndex[paramKey]].innerText.toLowerCase().trim();
            const paramValue = recognizedParams[paramKey].toLowerCase().trim();

            if (cellText !== paramValue) {
                match = false;
                break;
            }
        }

        if (match) {
            rows[i].style.color = '#000';
            rows[i].style.fontWeight = '600';

            for (let j = 0; j < cells.length; j++) {
                cells[j].style.backgroundColor = '#FA6400';
            }
        }
    }
}

function renderFitmentTable(variantId) {
    const data = getFitmentData();
    const section = document.querySelector('[data-fitment-table-section]');
    if (!data || !section) return;

    const variant = data.variants[String(variantId)];
    const rows = variant ? parseFitmentString(variant.fitment) : [];

    if (!variant || rows.length === 0) {
        section.style.display = 'none';
        return;
    }
    section.style.display = '';

    // Determine which columns have at least one non-empty value
    const visibleCols = ALLOWED_INDEXES.filter((idx) =>
        rows.some((row) => row[idx] != null && row[idx].trim() !== '')
    );

    // Heading
    const heading = section.querySelector('[data-fitment-table-heading]');
    if (heading) {
        const template = data.skuLabelTemplate || '';
        heading.textContent = template.replace('__SKU__', variant.sku || '');
    }

    // Sort: make, model, submodel alpha; year ascending
    const cellAt = (row, fieldIdx) => (row[fieldIdx] || '').trim().toLowerCase();
    rows.sort((a, b) => {
        let cmp = cellAt(a, 1).localeCompare(cellAt(b, 1));
        if (cmp !== 0) return cmp;
        cmp = cellAt(a, 2).localeCompare(cellAt(b, 2));
        if (cmp !== 0) return cmp;
        cmp = cellAt(a, 3).localeCompare(cellAt(b, 3));
        if (cmp !== 0) return cmp;
        return (parseInt(cellAt(a, 0), 10) || 0) - (parseInt(cellAt(b, 0), 10) || 0);
    });

    const table = section.querySelector('#fitmentTable');
    if (!table) return;

    // Header
    const headerRow = table.querySelector('thead tr');
    headerRow.innerHTML = '';
    visibleCols.forEach((idx) => {
        const th = document.createElement('th');
        if (idx === 13) th.classList.add('fitment-notes');
        th.textContent = (data.headers && data.headers[idx]) || '';
        headerRow.appendChild(th);
    });

    // Body
    const tbody = table.querySelector('tbody');
    tbody.innerHTML = '';
    rows.forEach((row, i) => {
        const tr = document.createElement('tr');
        if (i >= VISIBLE_ROW_COUNT) tr.style.display = 'none';
        visibleCols.forEach((idx) => {
            const td = document.createElement('td');
            if (idx === 13) td.classList.add('fitment-notes');
            const val = (row[idx] || '').trim();
            td.textContent = val === '*' ? 'All' : val;
            tr.appendChild(td);
        });
        tbody.appendChild(tr);
    });

    // Reset Show More button + open state
    const tableSection = section.querySelector('.table-section');
    if (tableSection) tableSection.classList.remove('table-section--open');

    const toggleBtn = section.querySelector('[data-fitment-table-toggle]');
    if (toggleBtn) {
        if (rows.length > VISIBLE_ROW_COUNT) {
            toggleBtn.style.display = '';
            toggleBtn.innerHTML = 'Show More';
        } else {
            toggleBtn.style.display = 'none';
        }
    }

    highlightRow(table);
}

const toggleTableRows = (section) => {
    section.classList.toggle('table-section--open');

    const tableRows = section.querySelectorAll('tbody tr');
    const tableButton = section.querySelector('[data-fitment-table-toggle]');
    const tableOpen = section.classList.contains('table-section--open');

    tableRows.forEach((row, index) => {
        row.style.display = !tableOpen && index >= VISIBLE_ROW_COUNT ? 'none' : '';
    });

    if (tableButton) {
        tableButton.innerHTML = tableOpen ? 'Show Less' : 'Show More';
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const data = getFitmentData();
    if (data && data.initialVariantId) {
        renderFitmentTable(data.initialVariantId);
    }

    const section = document.querySelector('[data-fitment-table-section] .table-section');
    if (section) {
        const tableButton = section.querySelector('[data-fitment-table-toggle]');
        if (tableButton) {
            tableButton.addEventListener('click', () => toggleTableRows(section));
        }
    }
});

document.addEventListener('variant:change', (e) => {
    const variant = e.detail && e.detail.variant;
    if (variant && variant.id != null) {
        renderFitmentTable(variant.id);
    }
});
